/*
akhila 10/27/2022 2701012930  bre UX Changes
Suresh Peddavoora 10/30/2022 2701012930  Added Class Name for Table Enhancements
Ashraf 10/30/2022 2701012930 fixed table pagination issue
Suresh Peddavoora 11/01/2022 2701012930  Modified Download configuration usage Button position in Table pagination
saikrishna 11/03/2022 2701012930 changed the paginationOptions
Sohel 11/05/2022 2701012930 rename download configurations
Akhila 11/08/2022 2701012930 added global search
Dilip 12/20/2022 2701012930 Changed usage title
Dilip 12/20/2022 2701012930 Removed search
akhila 12/21/2022 2701012930 changed search label
lalitha 12/22/2022 2701012930 added code and description in title
Ashraf 12/30/2022 01/02/2022 renamed usage header title
saikrishna 1/2/2023 2701012930 changed the download usage payload
saikrishna 01/04/2023 2701012930 changed the sourceType formula rule  to data calculations
Akhila 01/09/2023 2701012930 Fixed table data
manikanta 02/06/2023 2701012930 Fixed button label
*/

import React, {useEffect, useContext, useState} from 'react';
import capitalize from '../../../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {resetformulaUsagedata} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {Button, TablePagination} from '@material-ui/core';
import {ThemeContext} from './../../../../../themes/ThemeProvider';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {modulesText} from '../../../../../util/Content';


export default function Usage({setUsageState, fieldRowData, setValue}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {isLoading, successMsg, errorMsg, formulaUsageResponse} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      setUsageState(false);
      dispatch(resetformulaUsagedata());
    };
  }, []);


  const [rows, setRows] = useState(defaultRows);

  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);

  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  const object = formulaUsageResponse?.placeResponse ? formulaUsageResponse?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
          });
        });
    });
  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Name',
      field: 'codes',
      render: (rowData) => {
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
  ];
  return (
    <div>
      <div className={` mb-0 `}>
        <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
              Back To Search
          </Button>
        </div>
        <div className="custom-table custom-toolbar-icons global-field-table new-standard-textfields">
          <GuiTable
            title={`${fieldRowData.code} - ${fieldRowData.description} This Data Calculation has been used in the following places.`}
            columns={columns}
            data={values}
            textAlign="left"
            options={{
              paging: true,
              toolbar: true,
              search: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSize: rows,
              pageSizeOptions: tablePageRows,
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer new-standard-textfields">
                  <div className="mt-2">
                    <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      color="primary"
                      disabled={formulaUsageResponse.userMetrix === 'No'}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: '',
                            code: fieldRowData?.code ? fieldRowData.code : '',
                            description: fieldRowData?.description ? fieldRowData.description : '',
                            displayName: fieldRowData?.displayName ? fieldRowData?.displayName : '',
                            fileType: '',
                            recordFormatType: '',
                            returnType: fieldRowData?.returnType ? fieldRowData.returnType : '',
                            sourceType: 'DATA CALCULATION',
                          }),
                        );
                      }}
                    >
                     Download Configuration Usage
                    </Button>

                  </div>
                  <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
      )}
      {(successMsg || printUsageSuccessMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </div>
  );
}
